exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-row {\n  display: flex;\n  justify-content: space-between;\n}\n\n.data-row span {\n  line-height: 4.5rem;\n  font-size: 3rem;\n  font-weight: bold;\n}\n\n.data-row span:first-child {\n  color: #0d3a52;\n}\n\n.data-row span:nth-child(2) {\n  color: #00ceff;\n}\n\n", ""]);

// exports
